import { render, staticRenderFns } from "./GlareHero.vue?vue&type=template&id=3d29133a&"
import script from "./GlareHero.vue?vue&type=script&lang=ts&"
export * from "./GlareHero.vue?vue&type=script&lang=ts&"
import style0 from "./GlareHero.vue?vue&type=style&index=0&id=3d29133a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports